import { useEffect, useState } from "react"
import { EngagementService } from "@services/engagements/engagementService"
import { KeyDate } from "@models/keyDate.model"
import KeyDatesList from "./KeyDatesList"

interface KeyDatesPanelProps {
  engagementId: number
  objectiveId?: number
  title?: string
  emptyMessage?: string
  className?: string
}

const KeyDatesPanel = ({
  engagementId,
  objectiveId,
  title,
  emptyMessage,
  className,
}: KeyDatesPanelProps) => {
  const [keyDates, setKeyDates] = useState<KeyDate[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!engagementId || engagementId === -1) {
      setKeyDates([])
      setIsLoading(false)
      return
    }

    let cancelled = false

    ;(async () => {
      setIsLoading(true)
      try {
        const service = new EngagementService()
        const allKeyDates: KeyDate[] = []

        if (objectiveId != null && objectiveId !== -1) {
          allKeyDates.push(...(await service.getKeyDates(engagementId, objectiveId)))
        } else {
          const objectives = await service.getObjectives(engagementId)
          for (const obj of objectives) {
            allKeyDates.push(...(await service.getKeyDates(engagementId, obj.id)))
          }
        }

        allKeyDates.sort(
          (a, b) => new Date(a.date ?? 0).getTime() - new Date(b.date ?? 0).getTime()
        )
        if (!cancelled) setKeyDates(allKeyDates)
      } catch (error) {
        console.error("Error fetching key dates:", error)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [engagementId, objectiveId])

  return (
    <KeyDatesList
      keyDates={keyDates}
      isLoading={isLoading}
      title={title}
      emptyMessage={emptyMessage}
      className={className}
    />
  )
}

export default KeyDatesPanel
